import './index.css';
import { BsArrowDown, BsArrowUp } from 'react-icons/bs';
import I18n from '../../../utilities/locale';
import React, { useEffect, useState } from 'react';
import Constants from '../../../constants';
import useTheme from '../../../utilities/hooks/theme';
import { View } from '../../../component';
import useGame from '../../../utilities/hooks/game';
import { useDispatch } from 'react-redux';

interface UpIconProps {
  fillColor?: any;
}

const UpIcon = ({ fillColor }: UpIconProps) => {
  return (
    <View className="contest-sorting-icon-wrapper">
      <BsArrowUp size={18} fill={fillColor} />
    </View>
  );
};

const DownIcon = ({ fillColor }: UpIconProps) => {
  return (
    <View className="contest-sorting-icon-wrapper">
      <BsArrowDown size={18} fill={fillColor} />
    </View>
  );
};

interface IconButtonProps {
  isAllContestList?: boolean;
  title?: string;
  sortType?: string;
  theme?: any;
  onPress?: React.MouseEventHandler;
  style?: any;
}

const IconButton = ({ onPress, isAllContestList, title, sortType, style }: IconButtonProps) => {
  return (
    <View className="contest-sorting-icon-btn-wrapper" onPress={onPress} style={style}>
      <p className="contest-sorting-icon-btn-label">{title}</p>
      {isAllContestList &&
        sortType != '' &&
        (sortType === 'UP' ? (
          <UpIcon fillColor={style['color']} />
        ) : (
          <DownIcon fillColor={style['color']} />
        ))}
    </View>
  );
};

interface ContestSortingHeaderProps {
  onUpdateChallenge?: any;
  challenges?: any;
  defaultSort?: any;
  onPressFilter?: any;
  isAllContestList?: any;
  onPressEntryFee?: any;
  onPressPrizePool?: any;
  onPressSpots?: any;
  onPressWinner?: any;
  activeFilter?: any;
  setActiveFilter?: any;
}

const ContestSortingHeader = ({
  onUpdateChallenge,
  onPressFilter,
  challenges,
  defaultSort,
  isAllContestList = false,
  onPressEntryFee,
  onPressPrizePool,
  onPressSpots,
  onPressWinner
}: ContestSortingHeaderProps) => {
  useEffect(() => {
    if (defaultSort === 'Entry') {
      setEntry('UP');
    } else if (defaultSort === 'PrizePool') {
      setPrizePool('UP');
    } else if (defaultSort === 'Winner') {
      setWinner('UP');
    } else if (defaultSort === 'Spots') {
      setSpots('UP');
    } else setEntry('UP');
  }, []);
  const { fantasyMatchClick, item: matchItem } = useGame();
  const { FantasyTheme: theme } = useTheme();
  const [prizePool, setPrizePool] = useState(''); //UP or DOWN
  const [winner, setWinner] = useState(''); //UP or DOWN
  const [spots, setSpots] = useState(''); //UP or DOWN
  const [entry, setEntry] = useState(''); //UP or DOWN
  const dispatch = useDispatch();
  const onClickPrizePool = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'PrizePool'
        }
      })
    );
    const myPrizePool = prizePool === '' ? 'DOWN' : prizePool === 'DOWN' ? 'UP' : 'DOWN';
    setPrizePool(myPrizePool);
    setSpots('');
    setWinner('');
    setEntry('');
    if (myPrizePool === 'DOWN') {
      onUpdateChallenge(challenges.sort((a: any, b: any) => a.winningsAmount - b.winningsAmount));
    } else {
      onUpdateChallenge(challenges.sort((a: any, b: any) => b.winningsAmount - a.winningsAmount));
    }
  };

  const onClickWinners = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Winner'
        }
      })
    );
    const myWinner = winner === '' ? 'DOWN' : winner === 'DOWN' ? 'UP' : 'DOWN';
    setWinner(myWinner);
    setPrizePool('');
    setSpots('');
    setEntry('');
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Winner'
        }
      })
    );
    if (myWinner === 'DOWN') {
      onUpdateChallenge(
        challenges.sort((a: any, b: any) => {
          const aLen = Object.keys(a.winningsPerPosition).length || 0;
          const bLen = Object.keys(b.winningsPerPosition).length || 0;
          return aLen - bLen;
        })
      );
    } else {
      onUpdateChallenge(
        challenges.sort((a: any, b: any) => {
          const aLen = Object.keys(a.winningsPerPosition).length || 0;
          const bLen = Object.keys(b.winningsPerPosition).length || 0;
          return bLen - aLen;
        })
      );
    }
  };

  const onClickSpots = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Spots'
        }
      })
    );
    const mySpots = spots === '' ? 'DOWN' : spots === 'DOWN' ? 'UP' : 'DOWN';
    setSpots(mySpots);
    setPrizePool('');
    setWinner('');
    setEntry('');
    if (mySpots === 'DOWN') {
      onUpdateChallenge(challenges.sort((a: any, b: any) => a.maximumPlayers - b.maximumPlayers));
    } else {
      onUpdateChallenge(challenges.sort((a: any, b: any) => b.maximumPlayers - a.maximumPlayers));
    }
  };

  const onClickEntry = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Entry'
        }
      })
    );
    const myEntry = entry === '' ? 'DOWN' : entry === 'DOWN' ? 'UP' : 'DOWN';
    setEntry(myEntry);
    setPrizePool('');
    setSpots('');
    setWinner('');
    if (myEntry === 'DOWN') {
      onUpdateChallenge(challenges.sort((a: any, b: any) => a.entryFee - b.entryFee));
    } else {
      onUpdateChallenge(challenges.sort((a: any, b: any) => b.entryFee - a.entryFee));
    }
  };

  const sortedBG = {
    backgroundColor: theme.contestListSortingBG
  };
  return (
    <View
      style={{
        backgroundColor: 'transparent',
        borderRadius: '0px',
        width: '58%'
      }}
      className="contest-sorting-container">
      <IconButton
        title={I18n.t('ENTRY')}
        sortType={entry}
        isAllContestList={isAllContestList}
        theme={theme}
        onPress={isAllContestList ? onClickEntry : onPressEntryFee}
        style={{
          color: defaultSort === 'Entry' ? '#f6d03f' : '#fff',
          borderBottom: defaultSort === 'Entry' ? '1px solid #f6d03f' : ''
        }}
      />

      <IconButton
        title={I18n.t('PRIZEPOOL')}
        sortType={prizePool}
        isAllContestList={isAllContestList}
        theme={theme}
        onPress={isAllContestList ? onClickPrizePool : onPressPrizePool}
        style={{
          color: defaultSort === 'PrizePool' ? '#f6d03f' : '#fff',
          borderBottom: defaultSort === 'PrizePool' ? '1px solid #f6d03f' : ''
        }}
      />

      <IconButton
        title={I18n.t('SPOTS')}
        sortType={spots}
        isAllContestList={isAllContestList}
        theme={theme}
        onPress={isAllContestList ? onClickSpots : onPressSpots}
        style={{
          color: defaultSort === 'Spots' ? '#f6d03f' : '#fff',
          borderBottom: defaultSort === 'Spots' ? '1px solid #f6d03f' : ''
        }}
      />

      <IconButton
        title={I18n.t('WINNERS')}
        sortType={winner}
        isAllContestList={isAllContestList}
        theme={theme}
        onPress={isAllContestList ? onClickWinners : onPressWinner}
        style={{
          color: defaultSort === 'Winner' ? '#f6d03f' : '#fff',
          borderBottom: defaultSort === 'Winner' ? '1px solid #f6d03f' : ''
        }}
      />

      <View style={sortedBG} className="contest-sorting-icon-btn-wrapper" onPress={onPressFilter}>
        <Constants.Svgs.FilterList
          fill={theme.contestListSortingTitleText}
          width={20}
          height={20}
        />
      </View>
    </View>
  );
};
export default React.memo(ContestSortingHeader);
